exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".continue-section[data-v-7bb7e184] {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding-top: 4rem;\n}\n.continueButton[data-v-7bb7e184] {\n  width: 100%;\n  max-width: 400px;\n  margin-bottom: 3rem;\n}\n.continueButton[data-v-7bb7e184] .button {\n  width: 100%;\n}\n", ""]);

// exports
